import kebabCase from 'lodash/kebabCase';

export default {
  methods: {
    bem(element, modifier, outputElement = false) {
      const blockClass = kebabCase(
        this.$options.className || this.$options.name
      );
      const elementClass = `${blockClass}__${element}`;
      const elementModifierClass = `${elementClass}--${modifier}`;

      if (element && modifier && outputElement) {
        return `${elementClass} ${elementModifierClass}`;
      }
      if (element && modifier && !outputElement) {
        return elementModifierClass;
      }
      if (element && !modifier) {
        return elementClass;
      }
      if (modifier) {
        return `${blockClass}--${modifier}`;
      }
      return blockClass;
    },
  },
};
